var _path, _path2, _path3, _circle, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 57.002H6v-45h60v45zM25.875 25.395L15.75 36.002l10.125 10.606c5.592 5.858 14.658 5.858 20.25 0L56.25 36.002 46.125 25.395c-5.592-5.858-14.658-5.858-20.25 0z",
    fill: "url(#paint0_linear_1288_32013)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 55.5h69V60h-69v-4.5zM6 12h60v4.5H6V12z",
    fill: "#76808F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.25 66L18 63.75 15.75 66 18 68.25 20.25 66zM3 25.5H0v3h3v-3z",
    fill: "#76808F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 41.25,
    cy: 30.75,
    r: 3.75,
    fill: "#76808F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.849 33.453a3.75 3.75 0 01-5.303-5.302 8.25 8.25 0 105.303 5.302z",
    fill: "#76808F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54 5.249l3 3 3-3-3-3-3 3z",
    fill: "#76808F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_32013",
    x1: 36,
    y1: 57.002,
    x2: 36,
    y2: 12.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessControl);
export default __webpack_public_path__ + "static/media/access-control.1202a18ea2f73c3a4369f2cb5113bd17.svg";
export { ForwardRef as ReactComponent };